"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckmarkIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const CheckmarkIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "15", height: "14", viewBox: "0 0 15 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.0711 0.179183C14.5244 0.494573 14.6363 1.11778 14.3209 1.57115L6.32091 13.0712C6.1518 13.3142 5.88364 13.4699 5.58868 13.4961C5.29372 13.5224 5.00229 13.4166 4.79289 13.2072L0.292893 8.7072C-0.0976311 8.31667 -0.0976311 7.68351 0.292893 7.29298C0.683417 6.90246 1.31658 6.90246 1.70711 7.29298L5.36178 10.9477L12.6791 0.429024C12.9945 -0.0243495 13.6177 -0.136207 14.0711 0.179183Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 }) })));
};
exports.CheckmarkIcon = CheckmarkIcon;
//# sourceMappingURL=checkmark_icon.js.map